import React from "react";
import { MdBolt, MdChevronLeft, MdChevronRight, MdVerified } from "react-icons/md";
import ProductCard from "../../components/ProductCard";
import { getProductImage, quickMenus } from "../../utils/ecommerce";

const HomePage = ({
  barangs,
  kategoris,
  selectedKategori,
  setSelectedKategori,
  displayedProducts,
  flashSaleProducts,
  flashRef,
  rekomendasiRef,
  scrollRow,
  openProduct,
  openFlashSale,
  storeTagline,
}) => (
  <main className="page-container">
    <section className="hero-layout">
      <div className="hero-banner">
        <div>
          <span>Produk Elektronik Rumah Tangga</span>
          <h1>{storeTagline || "ALL HOME APPLIANCES YOU NEED"}</h1>
          <p>Kulkas, TV, AC, mesin cuci, dispenser, kipas angin, dan kebutuhan rumah lainnya.</p>
        </div>
        <img
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='420' height='260' viewBox='0 0 420 260'%3E%3Crect x='20' y='50' width='180' height='120' rx='12' fill='%23fff' opacity='.95'/%3E%3Crect x='38' y='68' width='144' height='82' rx='6' fill='%23ffd7cb'/%3E%3Crect x='242' y='34' width='86' height='180' rx='13' fill='%23fff'/%3E%3Crect x='255' y='53' width='60' height='120' rx='9' fill='%23ffe8df'/%3E%3Ccircle cx='344' cy='128' r='48' fill='%23fff' opacity='.9'/%3E%3Cpath d='M315 128h58M344 99v58' stroke='%23ee4d2d' stroke-width='10' stroke-linecap='round'/%3E%3C/svg%3E"
          alt="Promo Elektronik"
        />
      </div>
      <div className="side-banners">
        <div>Produk resmi dan bergaransi</div>
        <div>Voucher Diskon s.d. 80%</div>
      </div>
    </section>

    <section className="quick-menu">
      {quickMenus.map((menu, index) => (
        <button
          key={menu}
          type="button"
          onClick={() => {
            if (menu === "Flash Sale") {
              openFlashSale();
            }
          }}
        >
          <span>{index === 3 ? <MdBolt /> : <MdVerified />}</span>
          {menu}
        </button>
      ))}
    </section>

    <section className="category-panel">
      <div className="panel-title">KATEGORI</div>
      <div className="category-grid">
        <button
          className={selectedKategori === "SEMUA" ? "active" : ""}
          type="button"
          onClick={() => setSelectedKategori("SEMUA")}
        >
          <img src={getProductImage(barangs[0])} alt="Semua" />
          Semua Produk
        </button>
        {kategoris.map((kategori) => (
          <button
            key={kategori.id}
            className={String(selectedKategori) === String(kategori.id) ? "active" : ""}
            type="button"
            onClick={() => setSelectedKategori(kategori.id)}
          >
            <img src={kategori.image} alt={kategori.nama} />
            {kategori.nama}
          </button>
        ))}
      </div>
    </section>

    {selectedKategori === "SEMUA" && (
      <section className="flash-panel">
        <div className="panel-header">
          <div className="flash-title">
            FLASH SALE <span>02</span>
            <span>58</span>
            <span>55</span>
          </div>
          <button type="button" onClick={openFlashSale}>
            Lihat Semua &gt;
          </button>
        </div>
        <button className="carousel-arrow left" type="button" onClick={() => scrollRow(flashRef, -1)}>
          <MdChevronLeft />
        </button>
        <div className="horizontal-products" ref={flashRef}>
          {flashSaleProducts.map((barang) => (
            <ProductCard barang={barang} compact key={barang.id} onOpen={openProduct} />
          ))}
        </div>
        <button className="carousel-arrow right" type="button" onClick={() => scrollRow(flashRef, 1)}>
          <MdChevronRight />
        </button>
      </section>
    )}

    <section className="recommendation-panel">
      <div className="panel-header sticky">
        <div className="recommend-title">REKOMENDASI</div>
        <div>{displayedProducts.length} produk</div>
      </div>
      <button
        className="carousel-arrow left recommendation"
        type="button"
        onClick={() => scrollRow(rekomendasiRef, -1)}
      >
        <MdChevronLeft />
      </button>
      <div className="product-grid" ref={rekomendasiRef}>
        {displayedProducts.map((barang) => (
          <ProductCard barang={barang} key={barang.id} onOpen={openProduct} />
        ))}
      </div>
      <button
        className="carousel-arrow right recommendation"
        type="button"
        onClick={() => scrollRow(rekomendasiRef, 1)}
      >
        <MdChevronRight />
      </button>
    </section>
  </main>
);

export default HomePage;
